
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="/press" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  Press
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          {/* Professional Profiles */}
          <div>
            <h3 className="text-xl font-bold mb-4">Professional Profiles</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://ae.linkedin.com/in/yazanhomsi" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a 
                  href="https://www.crunchbase.com/person/yazan-al-homsi" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer"
                >
                  Crunchbase
                </a>
              </li>
              <li>
                <a 
                  href="https://www.f6s.com/yazan-al-homsi" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer"
                >
                  F6S
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <p className="text-gray-300 mb-2">Vancouver, BC, Canada</p>
            <p className="text-gray-300 mb-4">Dubai, UAE</p>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-gray-300">© 2025 Yazan Al Homsi. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}